import { gsap } from 'gsap';

import { GetBy } from '../core/Element';
import { Basics } from '../core/Basics';
import { Maths } from '../utils/Maths';

export class SliderClick {
  _container;
  _holder;
  _items = [];
  _current = 0;
  _controls = {};
  opts;

  get total() {
    return this._items.length;
  }

  get progress() {
    return this._current / (this.total - 1);
  }

  set progress(value) {
    const clampedValue = Maths.clamp(value, 0, 1);
    this.goto_percentage(clampedValue);
  }

  get current() {
    return this._current;
  }

  get items() {
    return this._scroll._items;
  }

  constructor(__container, options = {}) {
    this._container = __container;
    this._holder = GetBy.class('__holder', __container)[0];
    this.opts = options;

    const itemClass = options.itemClass || ScrollItem__Gallery;
    this._items = [...GetBy.selector(options.selector || '[scroll-slider-item]', this._holder)].map((el, i) =>
      new itemClass(el, i)
    );

    /* CONTROLS */
    this._controls = {
      next: GetBy.selector('[scroll-slider-next]', options.domControls || __container)[0],
      prev: GetBy.selector('[scroll-slider-prev]', options.domControls || __container)[0],
      current: GetBy.selector('[scroll-slider-current]', options.domControls || __container)[0],
      total: GetBy.selector('[scroll-slider-total]', options.domControls || __container)[0],
      progress: GetBy.selector('[scroll-slider-progress]', options.domControls || __container)[0]
    };

    this.hide();
  }

  show() {
    this.progress = 0;
    this.update();

    if (this._controls.next) this._controls.next.addEventListener(Basics.clickEvent, () => this.next());
    if (this._controls.prev) this._controls.prev.addEventListener(Basics.clickEvent, () => this.prev());
    if (this._controls.total) this._controls.total.innerHTML = `${this.total}`.padStart(3, '0');
  }

  hide() {
    this._items.forEach(item => item.hide());

    if (this._controls.next) this._controls.next.removeEventListener(Basics.clickEvent, () => this.next());
    if (this._controls.prev) this._controls.prev.removeEventListener(Basics.clickEvent, () => this.prev());
  }

  update() {
    this._items.forEach((item, index) => {
      if (index === this._current) {
        item.show();
      } else {
        item.hide();
      }
    });

    if (this._controls.current) {
      this._controls.current.innerHTML = `${this._current + 1}`.padStart(3, '0');
    }
    if (this._controls.progress) {
      gsap.to(this._controls.progress, { drawSVG: `${0}% ${this.progress * 100}%` });
    }
  }

  next() {
    this._current = (this._current + 1) % this.total;
    this.update();
  }

  prev() {
    this._current = (this._current - 1 + this.total) % this.total;
    this.update();
  }

  gotoIndex(__n) {
    this._current = Maths.clamp(__n, 0, this.total - 1);
    this.update();
  }

  goto_percentage(__p) {
    const index = Math.round(__p * (this.total - 1));
    this.gotoIndex(index);
  }

  dispose() {
    if (this._controls.next) this._controls.next.removeEventListener(Basics.clickEvent, () => this.next());
    if (this._controls.prev) this._controls.prev.removeEventListener(Basics.clickEvent, () => this.prev());
    this._items = [];
  }
}

export class ScrollItem__Gallery {
  _image;
  _dom;
  _index;

  constructor(__d, __i) {
    this._dom = __d;
    this._index = __i;
    this._image = GetBy.selector('img', __d)[0];
  }

  show() {
    gsap.set(this._dom, { opacity: 1 });
  }

  hide() {
    gsap.set(this._dom, { opacity: 0 });
  }
}
